import type { ReactNode } from "react";
import { useHostname } from "@/lib/ssr";
import { isGuidesEnabled } from "@/lib/guidesFlag";
import NotFound from "@/pages/NotFound";

/** The guides exist only where they're on (staging until the owner approves them); a real 404 elsewhere. */
export const GuidesOnly = ({ children }: { children: ReactNode }) => (isGuidesEnabled(useHostname()) ? <>{children}</> : <NotFound />);

/** Renders its children only where the guides are on: for links to them from other pages. */
export const IfGuides = ({ children }: { children: ReactNode }) => (isGuidesEnabled(useHostname()) ? <>{children}</> : null);
